import Liquid from './Liquid.vue';

export default Liquid;
